/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmCompanyOwnInformation_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, crmOwningOrganisationClientId?: string | null, linkedSystemOrganisationId?: string | null };

export type ModifyCrmOrg_CrmCompanyOwnInformationMutationVariables = Types.Exact<{
  input: Array<Types.CrmOrganisationModifyInput>;
}>;


export type ModifyCrmOrg_CrmCompanyOwnInformationMutation = { modifyCrmOrganisation: { __typename: 'CrmOrganisationModifyResult', crmOrganisations: Array<{ __typename: 'CrmCompany', id: string, title: string, crmOwningOrganisationClientId?: string | null, linkedSystemOrganisationId?: string | null }> } };

export const CrmCompanyOwnInformation_CrmCompanyFragmentDoc = gql`
    fragment CrmCompanyOwnInformation_CrmCompany on CrmCompany {
  id
  title
  crmOwningOrganisationClientId
  linkedSystemOrganisationId
}
    `;
export const ModifyCrmOrg_CrmCompanyOwnInformationDocument = gql`
    mutation ModifyCrmOrg_CrmCompanyOwnInformation($input: [CrmOrganisationModifyInput!]!) {
  modifyCrmOrganisation(input: $input) {
    crmOrganisations {
      ...CrmCompanyOwnInformation_CrmCompany
    }
  }
}
    ${CrmCompanyOwnInformation_CrmCompanyFragmentDoc}`;
export type ModifyCrmOrg_CrmCompanyOwnInformationMutationFn = Apollo.MutationFunction<ModifyCrmOrg_CrmCompanyOwnInformationMutation, ModifyCrmOrg_CrmCompanyOwnInformationMutationVariables>;

/**
 * __useModifyCrmOrg_CrmCompanyOwnInformationMutation__
 *
 * To run a mutation, you first call `useModifyCrmOrg_CrmCompanyOwnInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyCrmOrg_CrmCompanyOwnInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyCrmOrgCrmCompanyOwnInformationMutation, { data, loading, error }] = useModifyCrmOrg_CrmCompanyOwnInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyCrmOrg_CrmCompanyOwnInformationMutation(baseOptions?: Apollo.MutationHookOptions<ModifyCrmOrg_CrmCompanyOwnInformationMutation, ModifyCrmOrg_CrmCompanyOwnInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyCrmOrg_CrmCompanyOwnInformationMutation, ModifyCrmOrg_CrmCompanyOwnInformationMutationVariables>(ModifyCrmOrg_CrmCompanyOwnInformationDocument, options);
      }
export type ModifyCrmOrg_CrmCompanyOwnInformationMutationHookResult = ReturnType<typeof useModifyCrmOrg_CrmCompanyOwnInformationMutation>;
export type ModifyCrmOrg_CrmCompanyOwnInformationMutationResult = Apollo.MutationResult<ModifyCrmOrg_CrmCompanyOwnInformationMutation>;
export type ModifyCrmOrg_CrmCompanyOwnInformationMutationOptions = Apollo.BaseMutationOptions<ModifyCrmOrg_CrmCompanyOwnInformationMutation, ModifyCrmOrg_CrmCompanyOwnInformationMutationVariables>;